<ng-container [formGroup]="beFormGroup">
  <label
    [for]="beFormControlName"
    class="be-form-select-label"
    [ngClass]="
      beFormControl.hasError('required') &&
      (beFormControl.touched || isFormSubmitted)
        ? 'be-form-select-label--error'
        : ''
    "
    >{{ label }}</label
    >
    <div
      class="be-form-select-container"
    [ngClass]="
      beFormControl.hasError('required') &&
      (beFormControl.touched || isFormSubmitted)
        ? 'be-form-select-container--error'
        : ''
    "
      >
      <select
        [name]="beFormControlName"
        [id]="beFormControlName"
        [formControlName]="beFormControlName"
        class="be-form-select"
        >
        @if (placeholder) {
          <option value="" selected disabled hidden>
            {{ placeholder }}
          </option>
        }

        <!-- define default template as fallback if user doesn't provide template as input -->
        <ng-template #defaultTemplate let-option>{{
          option[optionKey] || option
        }}</ng-template>

        @for (option of options; track option; let i = $index) {
          <option
            [ngValue]="option"
            [attr.selected]="selectedOptionIndex === i || null"
            >
            <ng-container
              [ngTemplateOutlet]="optionTemplate || defaultTemplate"
              [ngTemplateOutletContext]="{ $implicit: option }"
              >
            </ng-container>
          </option>
        }
      </select>
      <svg viewBox="0 0 100 100" class="be-input-icon be-input-icon--right">
        <use href="assets/icons-v2/sprites.svg#chevron-down"></use>
      </svg>
    </div>
    @if (
      beFormControl.hasError('required') &&
      (beFormControl.touched || isFormSubmitted)
      ) {
      <app-be-helper-text
        [helperId]="beFormControlName + '-required'"
        helperType="error"
        >This is a required field</app-be-helper-text
        >
      }
    </ng-container>
